import styled from 'styled-components'

const StyledStartCharacterHands = styled.div`
  position: absolute;
  top: 204px;
  width: 100%;
  z-index: 2;
`

export default StyledStartCharacterHands